/**
 * 盘点车辆管理
 */
import React from "react";
import { Button, Row, Col, Icon, Tooltip } from "antd";
import PageLayout from "../../ui/PageLayout";
import http from "../../../axios/http";
import messager from "../../ui/messager";
import StockCheckVehicleEdit from "./StockCheckVehicleEdit";
import AddFromVehicle from "./AddFromVehicle";
import { global_data } from '../../ui/auth'

class StockCheckVehicleIndex extends React.Component {
  columns = [
    {
      title: "车架号",
      dataIndex: "vin",
      width: "15%",
    },
    {
      title: "车牌号",
      dataIndex: "plateNo",
      width: "10%",
    },
    {
      title: "车辆名",
      dataIndex: "name",
    },
    {
      title: "商户名",
      dataIndex: "memberName",
    },
    {
      title: "类型",
      dataIndex: "specialCustomer",
      width: "10%",
      format: {
        null: "商户车辆",
        0: "商户车辆",
        1: "手工新增",
      },
    },
    {
      title: "操作",
      dataIndex: "id",
      width: "10%",
      render: (text, record, index) => {
        return <div>{this.showOperation(record)}</div>;
      },
    },
  ];

  state = {
    visible: false,
    addVisible: false,
    editData: {},
    loadData: "",
  };

  showOperation(record) {
    var rslt = [];
    rslt.push(
      global_data.authCode.includes("STOCK_VEHICLE_LIST_UPDATE")?
      <Tooltip title="修改">
        <Icon
          type="edit"
          theme="filled"
          title="修改"
          className="table-operate-icon"
          onClick={this.update.bind(this, record)}
        />
      </Tooltip>
      :""
    );
    rslt.push(
      global_data.authCode.includes("STOCK_VEHICLE_LIST_DELETE")?
      <Tooltip title="移出盘点">
        <Icon
          type="stop"
          theme="filled"
          title="移出盘点"
          className="table-operate-icon"
          onClick={this.remove.bind(this, record)}
        />
      </Tooltip>
      :""
    );
    return rslt;
  }

  add = () => {
    this.setState({ editData: { specialCustomer: 1 } });
    this.showModal();
  };

  selectVehicle = () => {
    this.setState({ editData: {} });
    this.showAddModal();
  };

  remove = (info) => {
    messager.confirm("是否从盘点列表中移除此车辆？", () => {
      http.post({
        url: "/vehicleStockCheck/removeVehicle",
        data: { id: info.id },
        success: (res) => {
          messager.notify("操作成功");
          this.state.loadData();
        },
      });
    });
  };

  showModal = () => {
    this.setState({ visible: true });
  };
  hiddenModal = () => {
    this.setState({ visible: false });
  };

  showAddModal = () => {
    this.setState({ addVisible: true });
  };
  hiddenAddModal = () => {
    this.setState({ addVisible: false });
  };

  update = (info, e) => {
    this.setState({ editData: info });
    this.showModal();
  };

  render() {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <PageLayout
          condition={
            <Row>
              <Col span={24} style={{ textAlign: "right" }}>
                {global_data.authCode.includes("STOCK_VEHICLE_LIST_CHOOSE")?
                <Button
                  type="primary"
                  onClick={this.selectVehicle}
                  style={{ marginRight: "10px" }}
                >
                  选择车辆
                </Button>
                :""}
                {global_data.authCode.includes("STOCK_VEHICLE_LIST_ADD")?
                <Button type="primary" onClick={this.add}>
                  手工新增
                </Button>
                :""}
              </Col>
            </Row>
          }
          rowKey="code"
          url="/vehicleStockCheck/queryVehicles"
          columns={this.columns}
          loadData={(func) => {
            this.setState({ loadData: func });
          }}
        />
        <StockCheckVehicleEdit
          visible={this.state.visible}
          onCancel={this.hiddenModal.bind(this)}
          editData={this.state.editData}
          successCallback={this.state.loadData}
        />
        <AddFromVehicle
          visible={this.state.addVisible}
          onCancel={this.hiddenAddModal.bind(this)}
          editData={this.state.editData}
          successCallback={this.state.loadData}
        />
      </div>
    );
  }
}

export default StockCheckVehicleIndex;
